import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { SelectButton } from "primereact/selectbutton";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

type TransferProps = {
  onPrevious: () => void;
  onNext: () => void;
};
function Transfer(props: TransferProps) {
  const { t } = useTranslation();
  const [dataTrans, setDataTrans] = useState<any>(1);
  const [lte, setLTE] = useState<string>("internet.t-d1.de");
  const [wlanSSID, setWLANSSID] = useState<string>("Vib3D");
  const [wlanPasskey, setWLANPasskey] = useState<string>("DMT12345");
  const [ftpUpload, setFtpUpload] = useState<any>(0);
  const [ftpServer, setFtpServer] = useState<string>("");
  const [ftpUser, setFtpUser] = useState<string>("");
  const [ftpPassword, setFtpPassword] = useState<string>("");
  const [dataUrl, setDataUrl] = useState<string>("api.vib3d.dmt-group.com");
  const [dataEp, setDataEp] = useState<string>("java-api");
  const [configUrl, setConfigUrl] = useState<string>("rest.dmt.de");
  const [configEp, setConfigEp] = useState<string>("ekvs/getunacked");
  const [configEpAck, setConfigEpAck] = useState<string>("ekvs/ack");

  const [gpsEnable, setGpsEnable] = useState<any>(1);
  const [ledSignal, setLedSignal] = useState<any>(2);
  const [errors, setErrors] = useState<any>([]);
  const trans_network = [
    { name: "off", value: 0 },
    { name: "LTE", value: 1 },
    { name: "WLAN", value: 2 },
  ];

  const ftp_upload = [
    { name: "off", value: 0 },
    { name: "on", value: 1 },
  ];

  const gps_enable = [
    { name: "off", value: 0 },
    { name: "on", value: 1 },
  ];

  const led_config = [
    { name: "off", value: 0 },
    { name: "simple", value: 1 },
    { name: "full", value: 2 },
  ];

  const validate = () => {
    let error: any = {};
    if (lte === "") {
      error["lte"] = t('lte_apn_error');
      setErrors(error);
    }

    if (dataUrl === "") {
      error["dataUrl"] = t('data_url_error');
      setErrors(error);
    }
    if (dataEp === "") {
      error["dataEp"] = t('data_ep_error');
      setErrors(error);
    }
    if (configUrl === "") {
      error["configUrl"] = t('config_url_error');
      setErrors(error);
    }
    if (configEp === "") {
      error["configEp"] = t('config_ep_error');
      setErrors(error);
    }
    if (configEpAck === "") {
      error["configEpAck"] = t('config_ep_ack_error');
      setErrors(error);
    }
    if (Object.keys(error).length !== 0) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem("lang")!);

    let transferinfo = localStorage.getItem("transferInfo");
    if (transferinfo) {
      let jsonItem = JSON.parse(transferinfo);
      setDataTrans(jsonItem["dataTrans"]);
      setLTE(jsonItem["lte"]);
      setWLANSSID(jsonItem["wlanSSID"]);
      setWLANPasskey(jsonItem["wlanPasskey"]);
      setFtpUpload(jsonItem["ftpUpload"]);
      setFtpServer(jsonItem["ftpServer"]);
      setFtpUser(jsonItem["ftpUser"]);
      setFtpPassword(jsonItem["ftpPassword"]);
      setGpsEnable(jsonItem["gpsEnable"]);
      setLedSignal(jsonItem["ledSignal"]);
      setDataUrl(jsonItem["dataUrl"]);
      setDataEp(jsonItem["dataEp"]);
      setConfigUrl(jsonItem["configUrl"]);
      setConfigEp(jsonItem["configEp"]);
      setConfigEpAck(jsonItem["configEpAck"]);
    }
  }, [i18n.language]);

  return (
    <>
      <Card title={t("data_transfer")} className="InputForms_container mt-4">
        <div>
          <div className="grid">
            <div className="lg:col-6">
              <h3>{t('communication_param')}</h3>
              <div className="grid align-items-center" style={{ border: '2px solid #eee', borderRadius: '8px' }}>
                <div className="col-12 lg:col-6">
                  <h5 className="mb-2 ml-5">
                    {t("data_transmission_network")}:
                  </h5>
                </div>
                <div className="col-12 lg:col-6">
                  <Dropdown
                    className="p-inputtext-sm  mb-0"
                    value={dataTrans}
                    options={trans_network}
                    onChange={(e) => setDataTrans(e.value)}
                    optionLabel="name"
                    placeholder="Select Data Transmission Network"
                  />
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="mb-2 ml-5">{t("let_apn")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <InputText
                    className="p-inputtext-sm block mb-0 "
                    value={lte}
                    onChange={(e) => setLTE(e.target.value)}
                  />
                  <div className="col-12 p-0"><p className="error-message mb-0">{errors["lte"]}</p></div>
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="mb-2 ml-5">{t("wlan_ssid")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <InputText
                    className="p-inputtext-sm block mb-0 "
                    value={wlanSSID}
                    onChange={(e) => setWLANSSID(e.target.value)}
                  />
                  <div className="col-12 p-0"><p className="error-message mb-0">{errors["wlanSSID"]}</p></div>
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="mb-2 ml-5">{t("wlan_passkey")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <InputText
                    className="p-inputtext-sm block mb-0 "
                    value={wlanPasskey}
                    onChange={(e) => setWLANPasskey(e.target.value)}
                  />
                  <div className="col-12 p-0"><p className="error-message mb-0">{errors["wlanPasskey"]}</p></div>
                </div>
              </div>
              {/*<h3>{t('ftp_option')}</h3>*/}
              {/*<div className="grid align-items-center" style={{ border: '2px solid #eee', borderRadius: '8px' }}>*/}
              {/*  <div className="col-12 lg:col-6">*/}
              {/*    <h5 className="mb-2 ml-5">{t("enable_ftp_upload")}:</h5>*/}
              {/*  </div>*/}
              {/*  <div className="col-12 lg:col-6">*/}
              {/*    <Dropdown*/}
              {/*      className="p-inputtext-sm  mb-0"*/}
              {/*      value={ftpUpload}*/}
              {/*      options={ftp_upload}*/}
              {/*      onChange={(e) => setFtpUpload(e.value)}*/}
              {/*      optionLabel="name"*/}
              {/*      placeholder="Select FTP/SFTP Upload"*/}
              {/*    />*/}
              {/*  </div>*/}
              {/*  <div className="col-12 lg:col-6">*/}
              {/*    <h5 className="mb-2 ml-5">{t("ftp_server")}:</h5>*/}
              {/*  </div>*/}
              {/*  <div className="col-12 lg:col-6">*/}
              {/*    <InputText*/}
              {/*      className="p-inputtext-sm block mb-0"*/}
              {/*      value={ftpServer}*/}
              {/*      onChange={(e) => setFtpServer(e.target.value)}*/}
              {/*    />*/}
              {/*    <div className="col-12 p-0"><p className="error-message mb-0">{errors["ftpServer"]}</p></div>*/}
              {/*  </div>*/}
              {/*  <div className="col-12 lg:col-6">*/}
              {/*    <h5 className="mb-2 ml-5">{t("ftp_user")}:</h5>*/}
              {/*  </div>*/}
              {/*  <div className="col-12 lg:col-6">*/}
              {/*    <InputText*/}
              {/*      className="p-inputtext-sm block mb-0"*/}
              {/*      value={ftpUser}*/}
              {/*      onChange={(e) => setFtpUser(e.target.value)}*/}
              {/*    />*/}
              {/*    <div className="col-12 p-0"><p className="error-message mb-0">{errors["ftpUser"]}</p></div>*/}
              {/*  </div>*/}
              {/*  <div className="col-12 lg:col-6">*/}
              {/*    <h5 className="mb-2 ml-5">{t("ftp_password")}:</h5>*/}
              {/*  </div>*/}
              {/*  <div className="col-12 lg:col-6">*/}
              {/*    <InputText*/}
              {/*      className="p-inputtext-sm block mb-0"*/}
              {/*      value={ftpPassword}*/}
              {/*      onChange={(e) => setFtpPassword(e.target.value)}*/}
              {/*    />*/}
              {/*    <div className="col-12 p-0"><p className="error-message mb-0">{errors["ftpPassword"]}</p></div>*/}
              {/*  </div>*/}
              {/*</div>*/}
              <h3>{t('gps_settings')}</h3>
              <div className="grid align-items-center" style={{ border: '2px solid #eee', borderRadius: '8px' }}>
                <div className="col-12 lg:col-6">
                  <h5 className="mb-2 ml-5">{t("gps_module_enabled")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <Dropdown
                      className="p-inputtext-sm  mb-0"
                      value={gpsEnable}
                      options={gps_enable}
                      onChange={(e) => setGpsEnable(e.value)}
                      optionLabel="name"
                      placeholder="Select GPS Module Enabled"
                  />
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="mb-2 ml-5">{t("led_signals")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <Dropdown
                      className="p-inputtext-sm  mb-0"
                      value={ledSignal}
                      options={led_config}
                      onChange={(e) => setLedSignal(e.value)}
                      optionLabel="name"
                      placeholder="Select LED Signals"
                  />
                </div>
              </div>

            </div>

            <div className="lg:col-6 pl-3">
              <h3>{t('cloud_stand')}</h3>
              <div className="grid align-items-center" style={{ border: '2px solid #eee', borderRadius: '8px' }}>
                <div className="col-12 lg:col-6">
                  <h5 className="mb-2 ml-5">{t("network_data_url")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <InputText
                    className="p-inputtext-sm block mb-0"
                    value={'api.vib3d.dmt-group.com'}
                    onChange={(e) => setDataUrl(e.target.value)}
                    disabled
                  />
                  <div className="col-12 p-0"><p className="error-message mb-0">{errors["dataUrl"]}</p></div>
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="mb-2 ml-5">{t("network_data_ep")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <InputText
                    className="p-inputtext-sm block mb-0"
                    value={'java-api'}
                    onChange={(e) => setDataEp(e.target.value)}
                    disabled
                  />
                  <div className="col-12 p-0"><p className="error-message mb-0">{errors["dataEp"]}</p></div>
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="mb-2 ml-5">{t("network_config_url")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <InputText
                    className="p-inputtext-sm block mb-0"
                    value={'rest.dmt.de'}
                    onChange={(e) => setConfigUrl(e.target.value)}
                    disabled
                  />
                  <div className="col-12 p-0"><p className="error-message mb-0">{errors["configUrl"]}</p></div>
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="mb-2 ml-5">{t("network_config_ep")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <InputText
                    className="p-inputtext-sm block mb-0"
                    value={'ekvs/getunacked'}
                    onChange={(e) => setConfigEp(e.target.value)}
                    disabled
                  />
                  <div className="col-12 p-0"><p className="error-message mb-0">{errors["configEp"]}</p></div>
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="mb-2 ml-5">{t("network_config_ep_ack")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <InputText
                    className="p-inputtext-sm block mb-0"
                    value={'ekvs/ack'}
                    onChange={(e) => setConfigEpAck(e.target.value)}
                    disabled
                  />
                  <div className="col-12 p-0"><p className="error-message mb-0">{errors["configEpAck"]}</p></div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap align-items-center justify-content-center lg:justify-content-between">
            <p className="text-danger text-underline"></p>
            <p className="text-danger"></p>
            <div>
              <Button
                icon="pi pi-angle-left"
                label={t("previous")}
                className="p-button-outlined p-button-secondary"
                onClick={() => {
                  props.onPrevious();
                }}
              />
              <Button
                icon="pi pi-angle-right"
                label={t("next")}
                className="p-button-outlined p-button-secondary ml-2"
                iconPos="right"
                onClick={() => {
                  if (validate()) {
                    let transfer: any = {
                      dataTrans: dataTrans,
                      lte: lte,
                      wlanSSID: wlanSSID,
                      wlanPasskey: wlanPasskey,
                      ftpUpload: ftpUpload,
                      ftpServer: ftpServer,
                      ftpUser: ftpUser,
                      ftpPassword: ftpPassword,
                      gpsEnable: gpsEnable,
                      ledSignal: ledSignal,
                      dataUrl: dataUrl,
                      dataEp: dataEp,
                      configUrl: configUrl,
                      configEp: configEp,
                      configEpAck: configEpAck,
                    };
                    localStorage.setItem(
                      "transferInfo",
                      JSON.stringify(transfer)
                    );
                    props.onNext();
                  }
                }}
              />
            </div>
          </div>
        </div>
      </Card>
    </>
  );
}
export default Transfer;
